import { INotifierResponse } from "../../../../api/CircularEconomy/INotifiers";
import Page404 from "../../../../pages/auth/Page404";
import Page500 from "../../../../pages/auth/Page500";
import Loading from "../../../../leap-components/Loading";

const IsNotifierReady = (notifierResponse?: INotifierResponse) => {
  if (!notifierResponse) {
    return false;
  }

  if (notifierResponse.response.httpStatusCode === 404) {
    return false;
  }

  if (!notifierResponse.notifier) {
    return false;
  }

  return true;
};

const GetNotifierNotReadyComponent = (notifierResponse?: INotifierResponse) => {
  if (!notifierResponse) {
    return <Loading />;
  }

  if (notifierResponse.response.httpStatusCode === 404) {
    return <Page404 />;
  }

  if (!notifierResponse.notifier) {
    return <Page500 />;
  }

  return <Loading />;
};

export { IsNotifierReady, GetNotifierNotReadyComponent };
